"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
function BannerTabItem(props) {
    var _a = props || {}, chosed = _a.chosed, href = _a.href, text = _a.text;
    return (react_1.default.createElement("a", { className: (0, classnames_1.default)('btn-menu-item', {
            active: chosed,
        }), href: href }, text));
}
exports.default = BannerTabItem;
//# sourceMappingURL=BannerTabItem.js.map